<div class="ui basic segment">
    <app-header
        title="reporting.payroll.journalEntry.settingsTitle"
        [back]="true"
        [backRoute]="'/reporting/payroll/journal-entry'"
    >
    </app-header>
    <ui-banner variant="info" class="margin-bottom-3">
        <p>{{ 'reporting.payroll.journalEntry.glCodeOrDepartmentChangeNotice' | translate }}</p>
    </ui-banner>
    <journal-entry-report-settings-department-form
        [departments]="departments"
        (departmentCodeChange)="saveDepartment($event)"
    >
    </journal-entry-report-settings-department-form>
    <journal-entry-report-settings-line-items-form
        [journalEntryReportItemTemplates]="journalEntryReportItemTemplates"
        (journalEntryReportTemplateChange)="saveReportItemTemplateChange($event)"
    >
    </journal-entry-report-settings-line-items-form>
</div>
